module.exports = __webpack_public_path__ + "img/airtel-logo.2e1e057e.svg";